/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import ApexCharts from 'apexcharts';
import * as React from 'react';
import { connect } from 'react-redux';
import { Category, CategoryType } from '../common/Categories';
import './ColumnChart.css';

const data = {
  labels: [],
  datasets: [
    {
      label: '',
      backgroundColor: 'rgb(255,255,255)',
      borderColor: '#D3D3D3',
      borderWidth: 1,
      hoverBackgroundColor: '#ffbe00',
      hoverBorderColor: '#ffbe00',
      data: []
    }
  ]
};
interface Props {
  xaxisData: Array<string>,
  xaxisLabel?: string,
  yaxisLabel?: string,
  datasets: Array<any>,
  MaxBarNum: number,
  label?: string,
  category: Category
  isMenuExpanded: boolean
}
class GroupedColumnChart extends React.Component<Props, {}>{
  private chartInstance: ApexCharts | null = null;
  private chartContainerRef = React.createRef<HTMLDivElement>();
  private initScheduled = false;

  componentDidMount() {
    this.scheduleInitializeChart();
  }

  componentWillUnmount() {
    this.initScheduled = false;
    if (this.chartInstance) {
      this.chartInstance.destroy();
      this.chartInstance = null;
    }
  }

  scheduleInitializeChart() {
    if (this.initScheduled || this.chartInstance) {
      return;
    }

    const categoryCount = this.props.xaxisData?.length ?? 0;
    this.initScheduled = true;
    const run = () => this.initializeChart();

    if (categoryCount > 75 && typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(run, { timeout: 3000 });
    } else {
      run();
    }
  }

  initializeChart() {
    if (this.chartInstance || !this.chartContainerRef.current) {
      return;
    }

    const options: any = {
      chart: {
        height: 400,
        width: 0,
        type: 'bar',
        fontFamily: "Roboto, 'Open Sans', Arial, sans-serif",
        toolbar: {
          show: false
        },
        animations: {
          enabled: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '90%'
        },
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: false,
        width: 2,
        colors: ['transparent']
      },
      series: [],
      yaxis: {
        title: {
          text: ''
        }
      },
      fill: {
        opacity: 1

      },
      legend: {
        show: false
      },
      xaxis: {
        categories: [],
      },
      grid: {
        xaxis: {
          lines: {
            show: false
          }
        },
        yaxis: {
          lines: {
            show: false
          }
        },
      },

    };
    options.xaxis.categories = this.props.xaxisData as never[];
    options.series = this.props.datasets;

    options.yaxis.title.text = this.props.yaxisLabel;

    if (this.props.category.type === CategoryType.License) {
      options.tooltip = {
        marker: {
          show: false
        },
        y: {
          formatter: function (value: any, { seriesIndex, dataPointIndex, w }: any): any {
            return `${options.series[seriesIndex].label[dataPointIndex]  }:  ${  options.series[seriesIndex].data[dataPointIndex]  } days`;
          },
          title: {
            formatter: (seriesName: any) => '',
          },
        }
      };
      options.fill.colors = [function ({ value, seriesIndex, w }: any): any {
        return options.series[seriesIndex].backgroundColor[options.series[seriesIndex].data.indexOf(value)];
      }];
    }
    else {
      switch (this.props.category.id) {
        case 0:
        case 2:
          options.colors = ['#CFE1EE'];
          break;
        case 1:
        case 3:
          options.colors = ['#DFE9D6'];
          break;
        case 5:
          options.colors = ['#CFE1EE', '#DFE9D6'];
          break;
        default:
          options.colors = ['#CFE1EE'];
      }
      options.tooltip = {
        y: {
          formatter: function (value: any, { seriesIndex, dataPointIndex, w }: any): any {
            return value;
          }
        }
      };
    }


    const width: any = options.xaxis.categories.length * ((this.props.MaxBarNum * 20) + 50);
    options.chart.width = width > 500 ? width : 500;
    options.plotOptions.bar.columnWidth = width > 500?'90%':'50%';
    options.chart.height = 300;

    const chart: ApexCharts = new ApexCharts(
      this.chartContainerRef.current,
      options
    );
    this.chartInstance = chart;

    chart.render();


  }
    render() {
        const isMenuExpanded = this.props.isMenuExpanded;
        return (
            <div style={{ display: 'flex' }}>
                <div className={!isMenuExpanded ? 'chartAreaWrapper' : 'chartAreaWrapperExpanded'}>
                    <div className='chartScrollArea'>
                        <div ref={this.chartContainerRef} />
                    </div>
                    <div className='xAxisLabel'>
                        {this.props.xaxisLabel}
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state: any) => ({
  isMenuExpanded: state.navMenu.isMenuExpanded
});

export default connect(
  mapStateToProps, {}
)

(GroupedColumnChart);
